<div
    class="language-selectors"
    *ngIf="{
        canChangeCountry: canChangeCountry$ | async,
        openWWButtonText: openWWButtonText$ | async,
        selectedLanguage: selectedLanguage$ | async,
        marketLanguage: marketLanguage$ | async,
        currency: currency$ | async
    } as data"
>
    <div class="mobile-languages">
        <p class="language-option text-l m-18">
            {{ 'dev.footer.chooseCountry' | translate }}: &nbsp;
            <a
                class="pointer"
                style="color: white"
                [href]="
                    data?.marketLanguage && !!this.element?.settings?.general?.noNavigation
                        ? data?.marketLanguage?.href
                        : data?.marketLanguage?.baseUrl
                "
                (click)="openWW($event)"
                >{{ data.selectedLanguage.code | uppercase }} ( {{ data.currency.currencySymbol }} )</a
            >
        </p>
    </div>
    <div class="vertical-separator text-m">|</div>
    <div class="mobile-country change-market m-18 text-l link-raw" (click)="openWW($event)" [ngClass]="{ pointer: data.canChangeCountry }">
        {{ data.openWWButtonText | titlecase }}
    </div>
</div>
